import PptxGenJS from "pptxgenjs";
import {
  BRAND_WATERMARK,
  COLORS,
  PAGE_TITLE_TEXT,
  PRIVATE_AND_CONFIDENTIAL_TEXT,
  SPLIT_PANEL_BOTTOM,
} from "./components";

export const SPLIT_TOP_THREE_MASTER = "SPLIT_TOP_THREE_MASTER";

export const splitTopThreeMasterSlide: PptxGenJS.SlideMasterProps = {
  title: SPLIT_TOP_THREE_MASTER,
  background: {
    color: COLORS.PANEL,
  },
  objects: [
    PAGE_TITLE_TEXT,
    SPLIT_PANEL_BOTTOM,
    {
      rect: {
        x: 0,
        y: 5.5,
        w: "100%",
        h: 4.5,
        fill: { color: "ffffff" },
      },
    },
    PRIVATE_AND_CONFIDENTIAL_TEXT,
    BRAND_WATERMARK,
  ],
  slideNumber: {
    x: "50%",
    y: "95%",
    fontSize: 8,
    color: "#000000",
  },
};
